import { useState, useEffect } from "react";
import { supabase } from "./db";

export default function SupplierLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // Ovláda otvorenie/zatvorenie tabuľky

  // Stavy pre filtrovanie jednotlivých stĺpcov
  const [filterName, setFilterName] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [filterAction, setFilterAction] = useState("");
  const [filterDate, setFilterDate] = useState("");

  useEffect(() => {
    if (isOpen) {
      fetchLogs();
    }
  }, [isOpen]);

  const fetchLogs = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("supplier_logs")
      .select("*")
      .order("created_at", { ascending: false });

    if (data) setLogs(data);
    if (error) console.error("Chyba pri načítaní logov:", error);
    setLoading(false);
  };

  // Logika pre filtrovanie všetkých stĺpcov naraz
  const filteredLogs = logs.filter((log) => {
    const matchName = (log.supplier_name || "")
      .toLowerCase()
      .includes(filterName.toLowerCase());
    const matchEmail = (log.supplier_email || "")
      .toLowerCase()
      .includes(filterEmail.toLowerCase());
    const matchAction = (log.action || "")
      .toLowerCase()
      .includes(filterAction.toLowerCase());

    // Dátum a čas naformátujeme na text pre ľahké vyhľadávanie (napr. "2026" alebo "5. 4.")
    const dateString = new Date(log.created_at).toLocaleString("sk-SK");
    const matchDate = dateString.includes(filterDate);

    return matchName && matchEmail && matchAction && matchDate;
  });

  const inputStyle = {
    width: "100%",
    padding: "6px",
    borderRadius: "4px",
    border: "1px solid #cbd5e1",
    fontSize: "12px",
    marginTop: "5px",
    boxSizing: "border-box",
  };

  const thStyle = {
    padding: "10px",
    color: "#334155",
    fontSize: "13px",
    textAlign: "left",
    backgroundColor: "#f8fafc",
    borderBottom: "2px solid #e2e8f0",
  };
  const tdStyle = {
    padding: "12px 10px",
    fontSize: "13px",
    borderBottom: "1px solid #e2e8f0",
  };

  return (
    <div style={{ marginBottom: "30px" }}>
      {/* TLAČIDLO NA OTVORENIE SEKCIЕ */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="btn-outline"
        style={{
          width: "100%",
          padding: "15px",
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>📜 Aktivity dodávateľov (Audit Log)</span>
        <span>{isOpen ? "▲ Skryť" : "▼ Zobraziť"}</span>
      </button>

      {/* ROZBALENÁ TABUĽKA */}
      {isOpen && (
        <div className="card" style={{ marginTop: "15px", padding: "20px" }}>
          {loading ? (
            <p style={{ textAlign: "center", color: "#64748b" }}>
              Načítavam aktivity...
            </p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: "800px",
                }}
              >
                <thead>
                  <tr>
                    <th style={thStyle}>
                      Názov dodávateľa
                      <input
                        type="text"
                        placeholder="Filtrovať firmu..."
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                        style={inputStyle}
                      />
                    </th>
                    <th style={thStyle}>
                      Email užívateľa
                      <input
                        type="text"
                        placeholder="Filtrovať email..."
                        value={filterEmail}
                        onChange={(e) => setFilterEmail(e.target.value)}
                        style={inputStyle}
                      />
                    </th>
                    <th style={thStyle}>
                      Aktivita (Log)
                      <input
                        type="text"
                        placeholder="Filtrovať aktivitu..."
                        value={filterAction}
                        onChange={(e) => setFilterAction(e.target.value)}
                        style={inputStyle}
                      />
                    </th>
                    <th style={thStyle}>
                      Dátum a čas
                      <input
                        type="text"
                        placeholder="Filtrovať čas..."
                        value={filterDate}
                        onChange={(e) => setFilterDate(e.target.value)}
                        style={inputStyle}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLogs.length > 0 ? (
                    filteredLogs.map((log) => (
                      <tr key={log.id}>
                        <td style={tdStyle}>
                          <strong>{log.supplier_name || "Neznáme"}</strong>
                        </td>
                        <td style={tdStyle}>{log.supplier_email}</td>
                        <td style={tdStyle}>
                          <span
                            style={{
                              backgroundColor: "#eff6ff",
                              color: "#1d4ed8",
                              padding: "4px 8px",
                              borderRadius: "6px",
                              fontSize: "12px",
                            }}
                          >
                            {log.action}
                          </span>
                        </td>
                        <td style={tdStyle} suppressHydrationWarning>
                          {new Date(log.created_at).toLocaleString("sk-SK")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{
                          padding: "30px",
                          textAlign: "center",
                          color: "#64748b",
                        }}
                      >
                        Nenašli sa žiadne záznamy pre daný filter.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div
                style={{
                  marginTop: "15px",
                  fontSize: "13px",
                  color: "#64748b",
                  textAlign: "right",
                }}
              >
                Zobrazených záznamov: <strong>{filteredLogs.length}</strong>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
